<template>
  <div class="text-xs">
    <div v-if="issues.length === 0" class="text-green-400">✓ No validation issues</div>

    <div v-else class="space-y-1">
      <div class="flex items-center gap-3">
        <span v-if="errorCount > 0" class="text-red-400">❌ {{ errorCount }} error{{ errorCount === 1 ? '' : 's' }}</span>
        <span v-if="warningCount > 0" class="text-yellow-400">⚠ {{ warningCount }} warning{{ warningCount === 1 ? '' : 's' }}</span>
      </div>
      <ul class="space-y-0.5">
        <li v-for="(issue, i) in issues" :key="i">
          <button type="button" class="text-left hover:underline"
            :class="issue.severity === 'error' ? 'text-red-300' : 'text-yellow-300'"
            @click="$emit('select-rule', issue.ruleIndex)">
            {{ issue.severity === 'error' ? '❌' : '⚠' }} Rule {{ issue.ruleIndex + 1 }}: {{ issue.message }}
          </button>
        </li>
      </ul>
    </div>
  </div>
</template>

<script setup>
/**
 * BindingValidationSummary.vue
 *
 * Compact, read-only summary of validateMappingRules.js's output. Emits
 * 'select-rule' with a rule index when an issue is clicked — the parent
 * (MappingBindingEditor.vue) scrolls the corresponding row into view.
 * Purely a display component: it never calls the validator itself and
 * never mutates anything.
 */
import { computed } from 'vue';

const props = defineProps({
  issues: { type: Array, default: () => [] }, // ValidationIssue[] from validateMappingRules()
});
defineEmits(['select-rule']);

const errorCount   = computed(() => props.issues.filter(i => i.severity === 'error').length);
const warningCount = computed(() => props.issues.filter(i => i.severity === 'warning').length);
</script>
